import { useQuery } from '@apollo/client';
import InputStyles from '@components/InputFieldControlled/InputText.styles';
import InputMultiSelect from '@components/InputMultiSelect';
import InputSwitchControlled from '@components/InputSwitch/InputSwitchControlled';
import { GET_DATA_TRANSFORM_LANGUAGE_QUERY } from '@gql/language';
import { FormLabel, Grid, Stack, useMediaQuery } from '@mui/material';
import { isEmpty } from 'lodash';
import { useFormContext } from 'react-hook-form';
import AddMore from '../components/AddMore';

const InputLanguages = () => {
    const { control, watch } = useFormContext();

    const isMobile = useMediaQuery('(max-width:600px)');
    const isTablet = useMediaQuery('(max-width:900px)');
    const mobileMode = isMobile || isTablet;

    const { data: languageOptions } = useQuery(GET_DATA_TRANSFORM_LANGUAGE_QUERY, {
        fetchPolicy: 'cache-first',
        nextFetchPolicy: 'cache-first',
    });
    
    const languages = (languageOptions?.getDataTransformLanguage?.language ?? []).map(item => ({
        label: item.name,
        value: item._id,
    }));

    const levels = (languageOptions?.getDataTransformLanguage?.levelLanguage ?? []).map(item => ({
        label: item.level,
        value: item._id,
    }))

    return (
        <AddMore
            name={'candidate.languages'}
            control={control}
            defaultObject={{
                languageId: '',
                levelId: '',
                mandatory: false,
            }}
            addMoreText="Ajouter une langue"
            render={({ index, deleteButton }) => {
                const itemData = control?._formValues?.candidate?.languages?.[index];
                return (
                    <>
                        <Grid container justifyContent={'space-between'}>
                            <Grid paddingRight={!mobileMode ? 1 : 0} xs={12} md={4}>
                                <Stack style={{ flex: 1.2, zIndex: 90 - index * 4 }}>
                                    {!isMobile && !isTablet && (
                                        <FormLabel style={InputStyles.text}>
                                            {index === 0 && 'Langue maîtrisée'}
                                        </FormLabel>
                                    )}
                                    {mobileMode && <FormLabel style={InputStyles.text}>{'Langue maîtrisée'}</FormLabel>}
                                    <InputMultiSelect
                                        viewOnly={false}
                                        single
                                        control={control}
                                        name={`candidate.languages[${index}].languageId`}
                                        placeholder="Choisissez une langue"
                                        options={languages}
                                        defaultValue={itemData?.language?.name.toString()}
                                    />
                                </Stack>
                            </Grid>
                            <Grid paddingX={!mobileMode ? 1 : 0} xs={12} md={4}>
                                <Stack style={{ flex: 1.8, zIndex: 89 - index * 4 }}>
                                    {!isMobile && !isTablet && (
                                        <FormLabel style={InputStyles.text}>{index === 0 && 'Niveau'}</FormLabel>
                                    )}
                                    <InputMultiSelect
                                        viewOnly={false}
                                        single
                                        placeholder="Sélectionnez votre niveau de maîtrise"
                                        options={levels}
                                        control={control}
                                        required={!isEmpty(watch(`candidate.languages[${index}].languageId`))}
                                        name={`candidate.languages[${index}].levelId`}
                                        defaultValue={itemData?.levelLanguage?.level.toString()}
                                    />
                                </Stack>
                            </Grid>
                            <Grid
                                display={!mobileMode ? 'flex' : null}
                                alignItems={!mobileMode ? 'flex-end' : null}
                                paddingX={!mobileMode ? 1 : 0}
                                xs={9}
                                md={3}>
                                <InputSwitchControlled
                                    control={control}
                                    name={`candidate.languages[${index}].mandatory`}
                                    defaultValue={Boolean(itemData?.mandatory)}
                                    label="Exigé pour ce poste"
                                />
                            </Grid>
                            <Grid
                                paddingLeft={!mobileMode ? 1 : 0}
                                display="flex"
                                justifyContent={'flex-end'}
                                xs={2}
                                md={1}>
                                {deleteButton}
                            </Grid>
                        </Grid>
                    </>
                );
            }}
        />
    );
};

export default InputLanguages;
